import {Day, DayEnum, Planning, TypeCours} from './plannig.model';
import {DatePipe} from '@angular/common';
import {Inject, Injectable, LOCALE_ID} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlanningHelperService {
  private _ActivityDays: Day[] = [
    {label: 'Accès libre', id: DayEnum.freeAccess}, // salle de muscu loisir par ex.
    {label: 'Lundi', id: DayEnum.monday},
    {label: 'Mardi', id: DayEnum.tuesday},
    {label: 'Mercredi', id: DayEnum.wednesday},
    {label: 'Jeudi', id: DayEnum.thursday},
    {label: 'Vendredi', id: DayEnum.friday},
    {label: 'Samedi', id: DayEnum.saturday},
    {label: 'Dimanche', id: DayEnum.sunday},
  ];

  private _typeCours = [
    {id: 1, label: 'Cours'},
    {id: 2, label: 'Stage'},
  ];

  private _categorieCours = [
    {id: 1, label: 'EC libre'},
    {id: 2, label: 'Loisir'},
    {id: 3, label: 'EC libre et loisir'},
  ];
  constructor(@Inject(LOCALE_ID) private locale: string,) {
  }
  getActivityDays(): Day[] {
    return this._ActivityDays;
  }

  getTypeCours(): any {
    return this._typeCours;
  }

  getCategorieCours(): any {
    return this._categorieCours;
  }
  displayActivityDate(activity: Planning): string {
    if (activity?.type_cours === TypeCours.stage && activity.date_debut_stage && activity.date_fin_stage) {
      const datePipe = new DatePipe(this.locale);
      const dateDebutStage = datePipe.transform(activity.date_debut_stage, 'dd/MM/YY').toString();
      const dateFinStage = datePipe.transform(activity.date_fin_stage, 'dd/MM/YY').toString();
      return `Du ${dateDebutStage} au ${dateFinStage}`;
    }
    if (activity?.jour === DayEnum.freeAccess) {
      return 'Accès libre';
    }
    if (activity?.type_cours === TypeCours.cours && activity?.jour_label && activity?.heure_debut && activity?.heure_fin) {
      return `Le ${activity?.jour_label} de ${this.displayHour(activity?.heure_debut)} à ${this.displayHour(activity?.heure_fin)}`;
    }
    return 'Non indiqué';
  }

  displayHour(hour: string): string {
    if (hour) {
      const hour_array = hour.split(':');
      return `${hour_array[0]}h${hour_array[1]}`;
    }
    return '';
  }
}
